import { axios } from '@Root/API'

export const getAll = id => {
	return axios.get(`contact/${id}/snapshot-list`)
}
